import { render, staticRenderFns } from "./VisaView.vue?vue&type=template&id=6129b8e5&scoped=true"
import script from "./VisaView.vue?vue&type=script&lang=js"
export * from "./VisaView.vue?vue&type=script&lang=js"
import style0 from "./VisaView.vue?vue&type=style&index=0&id=6129b8e5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6129b8e5",
  null
  
)

export default component.exports